import React from 'react';

import { Grid } from 'src/shared/components/Grid';

import { PageSection, PageSectionProps } from './PageSection';
import { UnorderedList } from './UnorderedList';

export interface CirclePageSectionProps extends PageSectionProps {
    children: React.ReactNode;
}

export const CirclePageSection: React.FC<CirclePageSectionProps> = ({ children, ...props }) => {
    return (
        <PageSection
            {...props}
            css={{
                // All section headings should capitalize their first letter,
                // regardless of language...
                'h3:first-letter': {
                    textTransform: 'capitalize',
                },
                flex: '1',
                width: '100%',
            }}
        >
            {children}
        </PageSection>
    );
};

export interface CircleGridProps {
    minItemHeight?: string | number;
    className?: string;
}

export const CircleGrid: React.FC<CircleGridProps> = ({ children, minItemHeight, className }) => {
    return (
        <Grid
            as={UnorderedList}
            className={className}
            minItemWidth={300}
            expand={false}
            maxColumns={3}
            minItemHeight={minItemHeight}
        >
            {children}
        </Grid>
    );
};
